<div class="container mat-typography mat-body mat-app-background">
  <h2>{{ plan.attributes.PRODUCT_NAME }} - {{plan.price | currency}}</h2>
  <div class="indicators-and-enroll">
    <app-indicator-icons [plan]="plan"></app-indicator-icons>
    <app-enroll-button
      [enrollStartUrl]="enrollStartUrl"
      [specialEnrollmentUrl]="specialEnrollmentUrl"
      [plan]="plan"
      [isSep]="isSep">
    </app-enroll-button>
  </div>
</div>
